/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 -t --transform StoryIcon.glb 
Files: StoryIcon.glb [4.46KB] > C:\Users\fedde\Downloads\v2\StoryIcon-transformed.glb [4.42KB] (1%)
*/

import { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { Euler, Mesh, MeshStandardMaterial, Vector3 } from "three";
import { Icon, IconProps } from "../../components/Icon";
import { CalloutProps } from "../../components/Callout";

type GLTFResult = GLTF & {
  nodes: {
    WebExp_StoryIcon: Mesh;
  };
  materials: {
    ["CatHQ_Story Icon"]: MeshStandardMaterial;
  };
};

export function StoryIcon() {
  const normalizedPosition = new Vector3(0, 0, 0);
  const normalizedRotation = new Euler(0, 0, 0);
  const calloutProps: CalloutProps = {
    graphicTexturePath: "/images/IconGraphic.png",
    graphicGlb: "/models/Callout/CalloutPlanev02.glb",
    graphicLocation: new Vector3(-0.59, -0.1, 1.1),
    textTitle: "Story",
    textTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textTitleColor: "#ffffff",
    textTitleFontSize: 0.4,
    textTitlePosition: new Vector3(-0.6, 0, 1),
    textSubTitle: "Lore",
    textSubTitleFontSize: 0.2,
    textSubTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textSubTitleColor: "#00EAFF",
    textSubTitlePosition: new Vector3(-0.61, -0.4, 1.21),
    scaleSpeed: 5,
    pivotPoint: new Vector3(-2.98415, -0.45328, -45.602),
    active: false,
  };
  const iconProps: IconProps = {
    name: "Story",
    blenderPosition: new Vector3(-2.98415, 45.6027, -0.45328),
    idleRotationSpeed: 0.5,
    hoverTranslateY: 5,
    hoverLookAtFactor: 5,
    selectorDimensions: [8, 12, 8],
    paddingLeaveDimensions: [20, 20, 20],
    hoverRotationY: 4,
    cameraPositionSelected: new Vector3(-2.98415, -0.45328, -75.6027),
    cameraTargetSelected: new Vector3(-2.98415, -0.45328, -45.6027),
    calloutProps: calloutProps,
  };

  //REFS
  const exampleRef = useRef(null);
  const { nodes, materials } = useGLTF(
    "/models/StoryIcon-transformed.glb"
  ) as GLTFResult;
  return (
    <Icon
      name={iconProps.name}
      blenderPosition={iconProps.blenderPosition}
      idleRotationSpeed={iconProps.idleRotationSpeed}
      hoverTranslateY={iconProps.hoverTranslateY}
      hoverLookAtFactor={iconProps.hoverLookAtFactor}
      selectorDimensions={iconProps.selectorDimensions}
      paddingLeaveDimensions={iconProps.paddingLeaveDimensions}
      hoverRotationY={iconProps.hoverRotationY}
      cameraPositionSelected={iconProps.cameraPositionSelected}
      cameraTargetSelected={iconProps.cameraTargetSelected}
      calloutProps={calloutProps}
    >
      <group
        ref={exampleRef}
        position={normalizedPosition}
        rotation={normalizedRotation}
        scale={1}
      >
        <mesh
          geometry={nodes.WebExp_StoryIcon.geometry}
          material={materials["CatHQ_Story Icon"]}
          rotation={[Math.PI / 2, 0, -0.995]}
        />
      </group>
    </Icon>
  );
}

useGLTF.preload("/models/StoryIcon-transformed.glb");
